import { create } from 'zustand';

type SessionState = {
  communicationMode: 'direct' | 'webrtc';
  setCommunicationMode: (mode: 'direct' | 'webrtc') => void;
};

export const useSessionStore = create<SessionState>((set) => ({
  communicationMode: 'direct', // Default to direct for localhost/proxy
  setCommunicationMode: (mode) => set({ communicationMode: mode }),
}));